"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangePickerInputFieldBody = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2019 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
// This has to be a class because DayPickerInput refs to it internally.
// See https://github.com/gpbl/react-day-picker/issues/748 for more information
var DateRangePickerInputFieldBody = /** @class */ (function (_super) {
    tslib_1.__extends(DateRangePickerInputFieldBody, _super);
    function DateRangePickerInputFieldBody() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = react_1.default.createRef();
        _this.invokeInputMethod = function (key) {
            if (_this.inputRef.current) {
                _this.inputRef.current[key]();
            }
        };
        _this.blur = function () { return _this.invokeInputMethod("blur"); };
        _this.focus = function () { return _this.invokeInputMethod("focus"); };
        return _this;
    }
    Object.defineProperty(DateRangePickerInputFieldBody.prototype, "value", {
        get: function () {
            if (this.inputRef.current) {
                return this.inputRef.current.value;
            }
            return "";
        },
        enumerable: false,
        configurable: true
    });
    DateRangePickerInputFieldBody.prototype.render = function () {
        var className = this.props.className;
        return (react_1.default.createElement("div", { className: classnames_1.default("gd-date-range-picker-input-wrapper", className) },
            react_1.default.createElement("span", { className: "gd-date-range-picker-input-icon gd-icon-calendar" }),
            react_1.default.createElement("input", tslib_1.__assign({}, this.props, { ref: this.inputRef, className: "gd-date-range-picker-input-field input-text s-date-range-picker-input-field" }))));
    };
    return DateRangePickerInputFieldBody;
}(react_1.default.Component));
exports.DateRangePickerInputFieldBody = DateRangePickerInputFieldBody;
//# sourceMappingURL=DateRangePickerInputFieldBody.js.map